import { Trans } from 'react-i18next'
import i18n from 'core/common/i18n'
import { Grid } from 'core/components/Core'
import Typography from 'core/components/Typography'

function EditorTips() {
  return (
    <Grid item xs={12} md={4}>
      <Typography fontSize="medium" fontWeight="medium" mb={1}>
        {`${i18n.t('product.scopes.description.labelDescription')} *`}
      </Typography>
      <Typography fontSize="small" color="textSecondary" mt={2}>
        {i18n.t('product.productionDescription.label')}
      </Typography>
      <Typography fontSize="small" color="textSecondary" component="div" mb={2}>
        <Trans
          components={{ ul: <ul />, li: <li /> }}
          i18nKey="product.productionDescription.list"
        />
      </Typography>
    </Grid>
  )
}

export default EditorTips
